import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, Router } from "@angular/router";
import { AuthService } from "@services/auth/auth.service";
import { UiService } from "@services/ui/ui.service";

@Injectable({
    providedIn: 'root'
})
export class superAdminGuard implements CanActivate {
    // uiService: any;
    // router: any;

    constructor(
        private authSrv: AuthService,
        private uiService: UiService,
        private router: Router
    ) { }

    public canActivate(route: ActivatedRouteSnapshot) {
        let role = this.authSrv.getDecodedToken()?.role;
        if (role.includes('Administration$SuperAdmin')) {
            return true;
        }

        this.uiService.showSnackbar('You do not have access to this application');
        this.router.navigate(['/admin/home']);

        return false;
    }
}
